import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";
import * as i18n from "../common/i18n";
import MaterialTable from 'material-table'
import { reactLocalStorage } from 'reactjs-localstorage';
import { MeasurementDetailChart } from "../common/MeasurementDetailChart";
import TuneIcon from '@material-ui/icons/Tune';
import InfoIcon from '@material-ui/icons/Info';
import SubjectIcon from '@material-ui/icons/Subject';
import DetailDialog from '../common/DetailDialog';
import DetailTable from '../common/DetailTable';
import moment from "moment";
import gql from 'graphql-tag';
import Message from "./Message";
import * as graphql from '../common/graphql';
import * as helper from "../common/helper";
import ReloadIcon from '@material-ui/icons/Replay';
import Chip from '@material-ui/core/Chip';
import { withIAM, isInRoles, ROLE_ADMIN, ROLE_READER, ROLE_OWNER, ROLE_ASSISTANT, ROLE_EDITOR } from "../common/iam";
import { CsvBuilder } from 'filefy';
import LinearProgress from '@material-ui/core/LinearProgress';


const styles = theme => ({
});

const defaults = {
    uuid: false,
    imei: false,
    status: false,
    measurement_created: false,
    measurement_rssi: false,
    measurement_signal: false,
    battery: false,
    address: false,
    pageSize: 20,
};

const defaultsPropertyName = 'p71.devices.defaults';

const DeviceStatus = {
    "LEASED": i18n.get("devices.status.LEASED"),
    "DEFECTIVE": i18n.get("devices.status.DEFECTIVE"),
    "MAINTENANCE": i18n.get("devices.status.MAINTENANCE"),
    "STOCKED": i18n.get("devices.status.STOCKED"),
    "ASSEMBLY": i18n.get("devices.status.ASSEMBLY"),
}

const FindingTypes = {
    "LOW_BATTERY": i18n.get("quality.findingType.LOW_BATTERY"),
    "LATE_RESPONSE": i18n.get("quality.findingType.LATE_RESPONSE"),
    "UNPLAUSIBLE_LASTEST_MEASUREMENT_POINTS_LO": i18n.get("quality.findingType.UNPLAUSIBLE_LASTEST_MEASUREMENT_POINTS_LO"),
    "UNPLAUSIBLE_LASTEST_MEASUREMENT_POINTS_HI": i18n.get("quality.findingType.UNPLAUSIBLE_LASTEST_MEASUREMENT_POINTS_HI"),
    "UNPLAUSIBLE_LASTEST_MEASUREMENT_ML_NULL": i18n.get("quality.findingType.UNPLAUSIBLE_LASTEST_MEASUREMENT_ML_NULL"),
    "UNPLAUSIBLE_LASTEST_MEASUREMENT_ML_LO": i18n.get("quality.findingType.UNPLAUSIBLE_LASTEST_MEASUREMENT_ML_LO"),
    "UNPLAUSIBLE_LASTEST_MEASUREMENT_ML_HI": i18n.get("quality.findingType.UNPLAUSIBLE_LASTEST_MEASUREMENT_ML_HI"),
    "UNPLAUSIBLE_LASTEST_MEASUREMENT_MAX_DISTANCE_NULL": i18n.get("quality.findingType.UNPLAUSIBLE_LASTEST_MEASUREMENT_MAX_DISTANCE_NULL"),
    "UNPLAUSIBLE_LASTEST_MEASUREMENT_MIN_DISTANCE_NULL": i18n.get("quality.findingType.UNPLAUSIBLE_LASTEST_MEASUREMENT_MIN_DISTANCE_NULL"),
    "UNPLAUSIBLE_LASTEST_MEASUREMENT_DISTANCE_HI": i18n.get("quality.findingType.UNPLAUSIBLE_LASTEST_MEASUREMENT_DISTANCE_HI"),
    "UNPLAUSIBLE_LASTEST_MEASUREMENT_DISTANCE_LO": i18n.get("quality.findingType.UNPLAUSIBLE_LASTEST_MEASUREMENT_DISTANCE_LO"),
    "UNPLAUSIBLE_LASTEST_MEASUREMENT_VARIANCE_HI": i18n.get("quality.findingType.UNPLAUSIBLE_LASTEST_MEASUREMENT_VARIANCE_HI"),
    "UNPLAUSIBLE_LASTEST_MEASUREMENT_VARIANCE_LO": i18n.get("quality.findingType.UNPLAUSIBLE_LASTEST_MEASUREMENT_VARIANCE_LO"),
}

class Devices extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            message: null,
            details: null,
            hideAfter: 3000,
            variant: "info",
            exporting: false,
            configView: false,
            deviceDetails: false,
            deviceFindings: false,
            tableLoading: true,
            findingsData: [],
            measurementDetails: false,
            userSettings: reactLocalStorage.getObject(defaultsPropertyName, defaults),
        };

        this.tableRef = React.createRef();
    }

    default(id) {
        return this.state.userSettings[id] !== undefined ? this.state.userSettings[id] : defaults[id];
    }

    setDefault(id, value) {

        const newUserSettings = { ...this.state.userSettings };
        newUserSettings[id] = value;

        this.setState({ userSettings: newUserSettings }, () => {
            reactLocalStorage.setObject(defaultsPropertyName, newUserSettings);
        });
    }

    showMessage = (message, variant, details, hideAfter) => {
        this.setState({
            message: message,
            variant: variant ? variant : "info",
            hideAfter: hideAfter ? hideAfter : 5000,
            details: details ? details : null,
        })
    }

    closeMessage = () => {
        this.setState({
            message: null,
            details: null,
            hideAfter: 3000,
            variant: "info",
        })
    }

    getInput = (data) => {
        try {

            const input = {}
            helper.set(input, data, "status");
            helper.set(input, data, "notes");
            helper.set(input, data, "storage");
            return input;

        } catch (error) {
            throw new Error(i18n.get("tenants.error.validation"))
        }
    }

    handleConfigViewCancel = () => {
        this.setState({ configView: false })
    }

    handleDeviceTableCancel = () => {
        this.setState({ deviceDetails: false })
    }

    handleFindingsCancel = () => {
        this.setState({ deviceFindings: false, findingsData: [] })
    }

    fetchDeviceFindings = async (uuid) => {
        try {
            const result = await graphql.clientWithToken(this.props.accessToken).query({
                query: gql`
            query {
                findings(
                    subject: DEVICES
                    where: [{ column: "ref", comparator: IS, string: "${uuid}" }]
                ) {
                    totalCount
                    elements {
                        ... on Finding {
                            type
                            created {
                                X
                            }
                            ref
                            details
                        }
                    }
                }
            }`,
                fetchPolicy: "no-cache"
            });

            const searchResult = {
                page: 1,
                data: result.data.findings.elements.map(
                    (element) => {
                        return {
                            ref: element.ref ? element.ref : null,
                            type: element.type ? FindingTypes[element.type] : null,
                            created: element.created && element.created.X? `${moment(element.created.X, 'X').format('DD.MM.YYYY HH:mm')}` : null,
                            details: element.details ? helper.findingDetailsOf(element) : null
                        };
                    }),
                totalCount: result.data.findings.totalCount
            }

            this.handleDeviceFindingsChange(uuid, searchResult);
        }
        catch (error) {
            this.showMessage(error.message, "error");
        }
    }

    handleDeviceFindingsChange = async (uuid, findings) => {
        this.setState({
            device: uuid, findingsData: findings.data, tableLoading: false
        })
    }

    mapField(column) {
        return column;
    }

    configTable(obj) {
        const arr = []
        if (obj) {
            arr.push({ label: i18n.get("configurations.version"), value: obj["version"] })
            arr.push({ label: i18n.get("configurations.sWait"), value: new Intl.NumberFormat('de-DE').format(obj["sWait"]) })
            arr.push({ label: i18n.get("configurations.mlMin"), value: new Intl.NumberFormat('de-DE').format(obj["mlMin"]) })
            arr.push({ label: i18n.get("configurations.mlMax"), value: new Intl.NumberFormat('de-DE').format(obj["mlMax"]) })
            arr.push({ label: i18n.get("configurations.msMin"), value: new Intl.NumberFormat('de-DE').format(obj["msMin"]) })
            arr.push({ label: i18n.get("configurations.msMax"), value: new Intl.NumberFormat('de-DE').format(obj["msMax"]) })
            arr.push({ label: i18n.get("configurations.mmMax"), value: new Intl.NumberFormat('de-DE').format(obj["mmMax"]) })
            arr.push({ label: i18n.get("configurations.threshold"), value: new Intl.NumberFormat('de-DE').format(obj["threshold"]) })
            arr.push({ label: i18n.get("configurations.ringBuffer"), value: new Intl.NumberFormat('de-DE').format(obj["ringBuffer"]) })
            arr.push({ label: i18n.get("configurations.msLog"), value: new Intl.NumberFormat('de-DE').format(obj["msLog"]) })
            arr.push({ label: i18n.get("configurations.created"), value: moment(obj["created"]["isoString"]).format("DD.MM.YYYY, HH:mm:ss") })
            arr.push({ label: i18n.get("configurations.endpoints"), value: obj["endpoints"].map(e => <Chip label={e.address} style={{ marginRight: 8, marginBottom: 8 }} />) })
        }
        return arr
    }

    infoTable(status, lastLease, lastMeasurement, lastConfiguration, lastJournal) {
        // if (!lastMeasurement) lastMeasurement = {}
        const arr = []
        arr.push({ label: i18n.get("deviceDetails.status"), value: status ? DeviceStatus[status] : '-' })
        arr.push({ label: i18n.get("deviceDetails.firmware"), value: lastJournal ? lastJournal["firmware"] : '-' })
        arr.push({ label: i18n.get("deviceDetails.address"), value: lastLease && lastLease["building"] && lastLease["parcel"] ? `${lastLease["building"]["street"]}, ${lastLease["parcel"]["name"]}` : '-' })
        arr.push({ label: i18n.get("deviceDetails.empty"), value: lastLease && lastLease["building"] ? `${lastLease["building"]["zipCode"]} ${lastLease["building"]["place"]}` : '-' })
        arr.push({ label: i18n.get("deviceDetails.lastFlushMl"), value: lastMeasurement ? new Intl.NumberFormat('de-DE').format(lastMeasurement["ml"]) : '-'})
        arr.push({ label: i18n.get("deviceDetails.lastFlushMs"), value: lastMeasurement ? new Intl.NumberFormat('de-DE').format(lastMeasurement["ms"]) : '-'})
        arr.push({ label: i18n.get("deviceDetails.lastFlushAmbient"), value: lastMeasurement ? new Intl.NumberFormat('de-DE').format(lastMeasurement["cAmbient"]) : '-' })
        arr.push({ label: i18n.get("deviceDetails.empty"), value: null })
        arr.push({ label: i18n.get("deviceDetails.nextFlush"), value: lastMeasurement && lastConfiguration && lastMeasurement["created"] ? moment(lastMeasurement["created"]["isoString"]).add(lastConfiguration["sWait"], "seconds").format("DD.MM.YYYY, HH:mm:ss") : '-' })
        arr.push({ label: i18n.get("deviceDetails.empty"), value: null })
        arr.push({ label: i18n.get("deviceDetails.leaseStarts"), value: lastLease && lastLease["starts"] ? moment(lastLease["starts"]["isoString"]).format("DD.MM.YYYY, HH:mm:ss") : '-' })
        arr.push({ label: i18n.get("deviceDetails.leaseEnds"), value: lastLease && lastLease["ends"] ? moment(lastLease["ends"]["isoString"]).format("DD.MM.YYYY, HH:mm:ss") : '-' })
        arr.push({ label: i18n.get("deviceDetails.empty"), value: null })
        arr.push({ label: i18n.get("deviceDetails.tap"), value: lastLease && lastLease["tap"] ? `${lastLease["tap"]["name"]}, ${lastLease["tap"]["valve"]}, ${lastLease["tap"]["faucet"]}` : '-' })
        if (lastLease && lastLease["notes"]) {
            arr.push({ label: i18n.get("deviceDetails.empty"), value: lastLease["notes"] })
        }
        if (lastLease && lastLease["tenant"]) {
            arr.push({ label: i18n.get("deviceDetails.tenant"), value: lastLease["tenant"]["company"] })
        }

        return arr
    }

    exportCsv = async (columns, data) => {

        try {

            this.setState({
                exporting: true,
                progressValue: 0
            });

            const allDevices = [];
            let totalCount = 0;
            const first = 100;
            let offset = 0

            this.showMessage("Export wird angestoßen. Bitte verlassen Sie die Seite nicht, solange der Exportvorgang läuft.", "info");

            do {

                const filters = []
                for (const column of columns) {
                    if (column.tableData.filterValue !== undefined && column.tableData.filterValue !== null) {
                        filters.push({
                            column: column,
                            field: column.field,
                            type: column.type,
                            comparator: column.comparator,
                            value: column.tableData.filterValue
                        })
                    }
                }
                const find = helper.whereString(filters, this.mapField, ["uuid"]);
                const orderBy = helper.orderByString({orderDirection: "asc"}, this.mapField, "uuid", true)
                const result = await graphql.clientWithToken(this.props.accessToken).query({
                    query: gql`
                    query {
                        devices(first: ${first}, offset: ${offset}, where: ${find}, orderBy: ${orderBy}) {
                            totalCount
                            elements {
                                ... on Device {
                                    uuid,
                                    imei,
                                    status,
                                    notes,
                                    storage
                                    lastLease: leases(
                                        first: 1,
                                        offset: 0
                                        orderBy: [{ column: "ends", direction: DESC }] 
                                        ) {
                                            elements {
                                                ... on Lease {
                                                    address
                                                    tenant {
                                                        company
                                                    }
                                                    starts {
                                                        isoString   
                                                    }
                                                    ends {
                                                        isoString
                                                    }
                                                    notes
                                                }
                                            }
                                        }
                                    lastMeasurement: measurements(
                                        first: 1,
                                        offset: 0
                                        orderBy: [{ column: "created", direction: DESC }] 
                                        ) {
                                            elements {
                                                ... on Measurement {
                                                    created {
                                                        isoString
                                                    }
                                                    rssi
                                                    signal
                                                    battery
                                                }
                                            }
                                        }                                                     
                                            
                                    lastJournal: journals (
                                        first: 1,
                                        offset: 0
                                        orderBy: [{ column: "created", direction: DESC }] 
                                        ) {
                                        elements {
                                            ... on Journal {
                                                firmware
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                `,
                    fetchPolicy: "no-cache"
                });
                totalCount = result.data.devices.totalCount;
                offset = offset + first;
                for (const device of result.data.devices.elements) {
                    allDevices.push(
                        {
                            uuid: device.uuid,
                            imei: device.imei,
                            status: device.status,
                            notes: device.notes,
                            storage: device.storage,
                            measurement_created: device.lastMeasurement && device.lastMeasurement.elements && device.lastMeasurement.elements.length > 0 ? device.lastMeasurement.elements[0].created : null,
                            measurement_battery: device.lastMeasurement && device.lastMeasurement.elements && device.lastMeasurement.elements.length > 0 ? device.lastMeasurement.elements[0].battery : null,
                            measurement_rssi: device.lastMeasurement && device.lastMeasurement.elements && device.lastMeasurement.elements.length > 0 ? device.lastMeasurement.elements[0].rssi : null,
                            measurement_signal: device.lastMeasurement && device.lastMeasurement.elements && device.lastMeasurement.elements.length > 0 ? device.lastMeasurement.elements[0].signal : null,
                            site: device.lastLease && device.lastLease.elements && device.lastLease.elements.length > 0 ? device.lastLease.elements[0]["address"] : null,
                        }
                    )
                }

                if (totalCount !== 0) {
                    this.setState({
                        exporting: true,
                        progressValue: (allDevices.length / totalCount) * 100
                    });
                }
            } while (allDevices.length < totalCount);

            const builder = new CsvBuilder('Geräte.csv')
                .setDelimeter(";")
                .setColumns(columns.map(columnDef => columnDef.title))
                .addRows(allDevices.map(device => { return [device.uuid, device.imei, DeviceStatus[device.status], device.notes, device.storage, device.measurement_created ? moment(device.measurement_created).format("DD.MM.YYYY, HH:mm") : null, device.measurement_battery ? `${device.measurement_battery} %` : null, device.measurement_rssi ? `${device.measurement_rssi} dB` : null, device.measurement_signal ? `${device.measurement_signal} %` : null, device.site] }))
                .exportFile();

            this.setState({
                exporting: false,
                progressValue: 0
            });
        } catch (error) {
            this.setState({
                exporting: false,
                progressValue: 0
            });
            this.showMessage(error.message, "error");
        }

    }

    render() {

        return (
            <div style={{ maxWidth: '100%' }}>
                {this.state.exporting && <div style={{ width: "100%" }}><LinearProgress value={this.state.progressValue} variant={"determinate"} /></div>}
                <MaterialTable
                    components={{
                        Cell: helper.defaultCell,
                        FilterRow: helper.defaultFilter
                    }}
                    icons={helper.tableIcons}
                    onChangeRowsPerPage={pageSize => { this.setDefault("pageSize", pageSize) }}
                    onChangeColumnHidden={data => { this.setDefault(data["field"], data["hidden"]) }}
                    tableRef={this.tableRef}
                    localization={i18n.getLocalization()}
                    columns={[
                        {
                            title: i18n.get("devices.uuid"),
                            field: 'uuid',
                            hidden: this.default("uuid"),
                            cellStyle: {
                                minWidth: '100px',
                                maxWidth: '100px',
                            },
                            headerStyle: {
                                minWidth: '100px',
                                maxWidth: '100px',
                            },
                            defaultFilter: (this.props.pageData && this.props.pageData.uuid) || null,
                            editable: "never",
                            sorting: true,
                            filtering: true,
                            customSort: () => 0,
                        },
                        {
                            title: i18n.get("devices.imei"),
                            field: 'imei',
                            hidden: this.default("imei"),
                            cellStyle: {
                                minWidth: '300px',
                                maxWidth: '300px',
                            },
                            headerStyle: {
                                minWidth: '300px',
                                maxWidth: '300px',
                            },
                            defaultFilter: (this.props.pageData && this.props.pageData.imei) || null,
                            editable: "never",
                            sorting: true,
                            filtering: true
                        },
                        {
                            title: i18n.get("devices.status"),
                            field: 'status',
                            lookup: DeviceStatus,
                            hidden: this.default("status"),
                            cellStyle: {
                                minWidth: '150px',
                                maxWidth: '150px',
                            },
                            headerStyle: {
                                minWidth: '150px',
                                maxWidth: '150px',
                            },
                            defaultFilter: (this.props.pageData && this.props.pageData.status) || null,
                            editable: "onUpdate",
                            sorting: true,
                            filtering: true
                        },
                        {
                            title: i18n.get("devices.notes"),
                            field: 'notes',
                            hidden: this.default("notes"),
                            cellStyle: {
                                minWidth: '400px',
                                maxWidth: '400px',
                            },
                            headerStyle: {
                                minWidth: '400px',
                                maxWidth: '400px',
                            },
                            defaultFilter: (this.props.pageData && this.props.pageData.notes) || null,
                            editable: "onUpdate",
                            sorting: true,
                            filtering: true
                        },
                        {
                            title: i18n.get("devices.storage"),
                            field: 'storage',
                            hidden: this.default("storage"),
                            cellStyle: {
                                minWidth: '400px',
                                maxWidth: '400px',
                            },
                            headerStyle: {
                                minWidth: '400px',
                                maxWidth: '400px',
                            },
                            defaultFilter: (this.props.pageData && this.props.pageData.storage) || null,
                            editable: "onUpdate",
                            sorting: true,
                            filtering: true
                        },
                        {
                            title: i18n.get("devices.timestampOfLastMeasurement"),
                            field: 'measurement_created',
                            hidden: this.default("measurement_created"),
                            cellStyle: {
                                minWidth: '250px',
                                maxWidth: '250px',
                            },
                            headerStyle: {
                                minWidth: '250px',
                                maxWidth: '250px',
                            },
                            editable: "never",
                            sorting: true,
                            filtering: true,
                            type: "datetime",
                            filterComponent: helper.DateRangeFilter,
                            render: rowData => {
                                return rowData && rowData.lastMeasurement ? moment(rowData.measurement_created.isoString).format("DD.MM.YYYY, HH:mm:ss") : "-"
                            }
                        },
                        {
                            title: i18n.get("devices.lastBattery"),
                            field: 'measurement_battery',
                            editable: "never",
                            hidden: this.default("measurement_battery"),
                            cellStyle: {
                                minWidth: '250px',
                                maxWidth: '250px',
                            },
                            headerStyle: {
                                minWidth: '250px',
                                maxWidth: '250px',
                            },
                            sorting: true,
                            filtering: true,
                            type: "numeric",
                            filterComponent: helper.RangeFilter,
                            render: rowData => {
                                if (rowData && rowData.lastMeasurement) {
                                    // return helper.batteryIconOf(rowData.lastMeasurement.battery);
                                    return `${rowData.measurement_battery} %`;
                                } else {
                                    return "-"
                                }
                            }
                        },
                        {
                            title: i18n.get("devices.lastRssi"),
                            field: 'measurement_rssi',
                            hidden: this.default("measurement_rssi"),
                            cellStyle: {
                                minWidth: '250px',
                                maxWidth: '250px',
                            },
                            headerStyle: {
                                minWidth: '250px',
                                maxWidth: '250px',
                            },
                            editable: "never",
                            sorting: true,
                            filtering: true,
                            type: "numeric",
                            filterComponent: helper.RangeFilter,
                            render: rowData => {
                                if (rowData && rowData.lastMeasurement) {
                                    // return helper.signalBarIconOf(rowData.lastMeasurement.rssi);
                                    return `${rowData.measurement_rssi} dB`;
                                } else {
                                    return "-"
                                }
                            }
                        },
                        {
                            title: i18n.get("devices.lastSignal"),
                            field: 'measurement_signal',
                            hidden: this.default("measurement_signal"),
                            editable: "never",
                            sorting: true,
                            filtering: true,
                            type: "numeric",
                            cellStyle: {
                                minWidth: '250px',
                                maxWidth: '250px',
                            },
                            headerStyle: {
                                minWidth: '250px',
                                maxWidth: '250px',
                            },
                            filterComponent: helper.RangeFilter,
                            render: rowData => {
                                if (rowData && rowData.lastMeasurement) {
                                    // return helper.signalBarIconOf(rowData.lastMeasurement.rssi);
                                    return `${rowData.measurement_signal} %`;
                                } else {
                                    return "-"
                                }
                            }
                        },
                        {
                            title: i18n.get("devices.address"),
                            field: 'lease_address',
                            hidden: this.default("lease_address"),
                            cellStyle: {
                                minWidth: '400px',
                                maxWidth: '400px',
                            },
                            headerStyle: {
                                minWidth: '400px',
                                maxWidth: '400px',
                            },
                            defaultFilter: (this.props.pageData && this.props.pageData.address) || null,
                            editable: "never",
                            sorting: true,
                            filtering: true,
                        },

                    ]}
                    data={query =>
                        new Promise(async (resolve, reject) => {

                            try {

                                const where = helper.whereString(query["filters"], this.mapField, ["uuid", "status"]);
                                const orderBy = helper.orderByString(query, this.mapField, "uuid", query["orderBy"] && query["orderBy"]["field"] === "uuid" || query["orderBy"] === undefined);

                                const result = await graphql.clientWithToken(this.props.accessToken).query({
                                    query: gql`
                                    query {
                                        devices(first: ${query.pageSize}, offset: ${query.pageSize * query.page}, orderBy:${orderBy}, where:${where}) {
                                            totalCount
                                            elements {
                                                ... on Device {
                                                    id,
                                                    uuid,
                                                    imei,
                                                    status,
                                                    notes,
                                                    storage,
                                                    lastLease: leases(
                                                        first: 1,
                                                        offset: 0
                                                        orderBy: [{ column: "ends", direction: DESC }] 
                                                        ) {
                                                            elements {
                                                                ... on Lease {
                                                                    address
                                                                    building {
                                                                        street
                                                                        zipCode
                                                                        place
                                                                    }
                                                                    parcel {
                                                                        name
                                                                    }
                                                                    tap {
                                                                        name
                                                                        valve
                                                                        faucet
                                                                    }
                                                                    tenant {
                                                                        company
                                                                    }
                                                                    starts {
                                                                      isoString   
                                                                    }
                                                                    ends {
                                                                      isoString
                                                                    }
                                                                    notes
                                                                }
                                                            }
                                                        }
                                                    lastConfiguration: configurations(
                                                        first: 1,
                                                        offset: 0
                                                        orderBy: [{ column: "created", direction: DESC }] 
                                                        ) {
                                                            elements {
                                                                ... on Configuration {
                                                                    endpoints {
                                                                        address
                                                                    }
                                                                    id
                                                                    version
                                                                    sWait
                                                                    mlMax
                                                                    mlMin
                                                                    mmMax
                                                                    msLog
                                                                    msMax
                                                                    msMin
                                                                    ringBuffer
                                                                    threshold
                                                                    created {
                                                                      isoString
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    lastMeasurement: measurements(
                                                        first: 1,
                                                        offset: 0
                                                        orderBy: [{ column: "created", direction: DESC }] 
                                                        ) {
                                                            elements {
                                                                ... on Measurement {
                                                                    created {
                                                                        isoString
                                                                    }
                                                                    points {
                                                                        c
                                                                        ml
                                                                        mm
                                                                    }
                                                                    ml
                                                                    ms
                                                                    cAmbient
                                                                    rssi
                                                                    signal
                                                                    battery
                                                                }
                                                            }
                                                        }                                                     
                                                          
                                                    lastJournal: journals (
                                                        first: 1,
                                                        offset: 0
                                                        orderBy: [{ column: "created", direction: DESC }] 
                                                        ) {
                                                        elements {
                                                            ... on Journal {
                                                                firmware
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                `,
                                    fetchPolicy: "no-cache"
                                });

                                const searchResult = {
                                    page: query.page,
                                    data: result.data.devices.elements.map(
                                        (element) => {
                                            return {
                                                id: element.id,
                                                uuid: element.uuid,
                                                imei: element.imei,
                                                status: element.status,
                                                storage: element.storage,
                                                notes: element.notes,
                                                lastLease: element.lastLease && element.lastLease.elements ? element.lastLease.elements[0] : null,
                                                lastJournal: element.lastJournal && element.lastJournal.elements ? element.lastJournal.elements[0] : null,
                                                lastConfiguration: element.lastConfiguration && element.lastConfiguration.elements ? element.lastConfiguration.elements[0] : null,
                                                lastMeasurement: element.lastMeasurement && element.lastMeasurement.elements ? element.lastMeasurement.elements[0] : null,
                                                measurement_battery: element.lastMeasurement && element.lastMeasurement.elements && element.lastMeasurement.elements.length > 0 ? element.lastMeasurement.elements[0].battery : null,
                                                measurement_rssi: element.lastMeasurement && element.lastMeasurement.elements && element.lastMeasurement.elements.length > 0 ? element.lastMeasurement.elements[0].rssi : null,
                                                measurement_signal: element.lastMeasurement && element.lastMeasurement.elements && element.lastMeasurement.elements.length > 0 ? element.lastMeasurement.elements[0].signal : null,
                                                measurement_created: element.lastMeasurement && element.lastMeasurement.elements && element.lastMeasurement.elements.length > 0 ? element.lastMeasurement.elements[0].created : null,
                                                lease_address: element.lastLease && element.lastLease.elements && element.lastLease.elements.length > 0 ? element.lastLease.elements[0]["address"] : null,
                                            };
                                        }),
                                    totalCount: result.data.devices.totalCount
                                }

                                resolve(searchResult);
                            } catch (error) {
                                this.showMessage(error.message, "error");
                                reject(error);
                            }
                        })
                    }

                    actions={[{
                        isFreeAction: true,
                        icon: () => { return <ReloadIcon /> },
                        tooltip: i18n.get("general.reload"),
                        onClick: async (event, rowData) => {
                            this.tableRef.current.onQueryChange();
                        }
                    }, {
                        isFreeAction: false,
                        icon: () => { return <InfoIcon /> },
                        tooltip: i18n.get("devices.deviceDetails"),
                        onClick: (event, rowData) => {
                            this.setState({ data: this.infoTable(rowData.status, rowData.lastLease, rowData.lastMeasurement, rowData.lastConfiguration, rowData.lastJournal), device: rowData.uuid, deviceDetails: true })
                        }
                    }, {
                        isFreeAction: false,
                        icon: () => { return <TuneIcon /> },
                        tooltip: i18n.get("devices.configView"),
                        onClick: (event, rowData) => {
                            this.setState({ data: this.configTable(rowData.lastConfiguration), device: rowData.uuid, configView: true })
                        }
                    }, {
                        isFreeAction: false,
                        icon: () => { return <SubjectIcon /> },
                        tooltip: i18n.get("devices.deviceFindings"),
                        onClick: (event, rowData) => {
                            this.setState({
                                deviceFindings: true,
                                tableLoading: true,
                                device: rowData.uuid
                            })
                            this.fetchDeviceFindings(rowData.uuid)
                        }
                    },

                    ]}

                    detailPanel={rowData => {
                        return <MeasurementDetailChart data={rowData && rowData.lastMeasurement ? rowData.lastMeasurement.points : []} />
                    }}

                    title={i18n.get("devices.title")}
                    options={{
                        addRowPosition: "first",
                        exportButton: !this.state.exporting,
                        exportCsv: this.exportCsv,
                        filtering: true,
                        showTitle: false,
                        debounceInterval: 1000,
                        search: false,
                        columnsButton: true,
                        pageSize: this.default("pageSize"),
                        pageSizeOptions: [5, 20, 50]
                    }}

                    editable={{
                        isEditable: rowData => isInRoles(this.props.roles, [ROLE_ADMIN, ROLE_OWNER, ROLE_EDITOR]),
                        onRowUpdate: (newData, oldData) =>
                            new Promise(async (resolve, reject) => {

                                try {

                                    const input = this.getInput(newData);

                                    const result = await graphql.clientWithToken(this.props.accessToken).mutate({
                                        variables: {
                                            "id": newData.id,
                                            "input": input,
                                        },
                                        mutation: gql`
                                        mutation updateDevice($id: ID!, $input: DeviceInput!) {
                                            updateDevice(id: $id, input: $input) {
                                                id
                                            }
                                        }
                                    `,
                                    });

                                    this.showMessage(i18n.get("devices.message.onRowUpdate.success"), "success")
                                    resolve(result);

                                } catch (error) {
                                    this.showMessage(i18n.get("devices.message.onRowUpdate.error"), "error", error.message)
                                    reject(error);
                                }
                            })
                    }}

                />

                <Message
                    hideAfter={this.state.hideAfter}
                    onClose={this.closeMessage}
                    variant={this.state.variant}
                    message={this.state.message}
                    details={this.state.details}
                    open={this.state.message !== null}
                />

                <DetailDialog
                    open={this.state.configView}
                    data={this.state.data}
                    onCancel={this.handleConfigViewCancel}
                    dialogTitle={`${i18n.get("devices.dialog.configView.title")} ${this.state.device}`}
                    cancelText={i18n.get("devices.dialog.configView.cancel")} />

                <DetailDialog
                    open={this.state.deviceDetails}
                    data={this.state.data}
                    onCancel={this.handleDeviceTableCancel}
                    dialogTitle={`${i18n.get("devices.dialog.deviceDetails.title")} ${this.state.device}`}
                    cancelText={i18n.get("devices.dialog.deviceDetails.cancel")} />

                <DetailTable
                    open={this.state.deviceFindings}
                    data={this.state.findingsData}
                    onCancel={this.handleFindingsCancel}
                    dialogTitle={`${i18n.get("devices.dialog.findings.title")} ${this.state.device}`}
                    cancelText={i18n.get("devices.dialog.findings.cancel")}
                    tableLoading={this.state.tableLoading}
                    columns={[
                        { title: i18n.get("devices.dialog.findings.type"), field: 'type', sorting: false },
                        { title: i18n.get("devices.dialog.findings.created"), field: 'created', sorting: false },
                        { title: i18n.get("devices.dialog.findings.details"), field: 'details', sorting: false },
                    ]} />

            </div>
        )
    }
}

Devices.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withIAM(withStyles(styles, { withTheme: true })(Devices))